<mat-expansion-panel [expanded]="index === 0">
  <mat-expansion-panel-header (opened)="panelOpenState = true" (closed)="panelOpenState">
    <mat-checkbox class="example-margin" [checked]="allComplete" [indeterminate]="someComplete()"
      (click)="$event.stopPropagation()" (change)="setAll($event.checked); addOrRemoveToPersonaSelectedAll()">
      {{label.name}}
    </mat-checkbox>
  </mat-expansion-panel-header>

  <div *ngFor="let sublabel of label.sublabels, let i = index">
    <div class="thumbnail"
      *ngIf="sublabel?.name != 'Public' && sublabel?.name != 'Inscrit' && sublabel?.name != 'Licencié'">
      <mat-checkbox (ngModelChange)="updateAllComplete()" [(ngModel)]="sublabel.completed"
        (ngModelChange)="updateAllComplete()" (change)="addOrRemoveToPersonaSelected(sublabel.name)">
        <div class="thumbnail_content">
          <h3>{{sublabel.name}}</h3>
          <p *ngIf="sublabel.name == 'Marin dans L\'âme'">Le marin dans l'âme, vous aimez être sur l'eau mais ne savez
            par
            forcément faire de la voile.</p>
          <p *ngIf="sublabel.name == 'Marin 3.0'">Le marin occasionnel, vous savez faire de la voile et vous aimez ça
            mais
            en pratique occasionnelle.</p>
          <p *ngIf="sublabel.name == 'Freerider'">Le Freerider, pratiquant libre et autonome sans club avec son propre
            matériel (funboarder, kitesurfer).</p>
          <p *ngIf="sublabel.name == 'Navigateur'">Le navigateur, passionné de voile, vous possédez votre propre
            bateau
            et
            naviguez régulièrement.</p>
          <p *ngIf="sublabel.name == 'Compétiteur'">Le compétiteur, vous participez à des regates régulièrement pour
            le
            plaisir.</p>
          <p *ngIf="sublabel.name == 'Performeur'">Le performer, compétiteur de haut niveau à la recherche de
            performance.
          </p>
        </div>
      </mat-checkbox>
    </div>
  </div>
</mat-expansion-panel>